import React, { useEffect, useRef } from 'react'
import QRCode from 'qrcode'

const QRCodeGenerator = ({ data, size = 200, className = '' }) => {
  const canvasRef = useRef(null)

  useEffect(() => {
    if (data && canvasRef.current) {
      QRCode.toCanvas(
        canvasRef.current,
        typeof data === 'string' ? data : JSON.stringify(data),
        {
          width: size,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF',
          },
        },
        (error) => {
          if (error) console.error('Error generating QR code:', error)
        }
      )
    }
  }, [data, size])

  if (!data) {
    return (
      <div
        className={`flex items-center justify-center bg-gray-100 ${className}`}
        style={{ width: size, height: size }}
      >
        <span className='text-gray-400 text-sm'>No data</span>
      </div>
    )
  }

  return <canvas ref={canvasRef} className={className} />
}

export default QRCodeGenerator
